(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-accordion-video')) {
    class ProductAccordionVideo extends HTMLElement {
      constructor() {
        super();
        this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.handlePause = this.handlePause.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handleLoadedMetadata = this.handleLoadedMetadata.bind(this);
        this.handleQualityToggleClick = this.handleQualityToggleClick.bind(this);
        this.handleQualityOptionClick = this.handleQualityOptionClick.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('.product-accordion-video__play');
        if (!this.video || !this.playButton) return;

        this.qualityToggle = this.querySelector('.product-accordion-video__quality-toggle');
        this.qualityCurrent = this.querySelector('.product-accordion-video__quality-current');
        this.qualityMenu = this.querySelector('.product-accordion-video__quality-menu');
        this.qualityOptions = Array.from(this.querySelectorAll('[data-quality][data-quality-url]'));
        this.loadingIndicator = this.querySelector('.product-accordion-video__loading');
        this.loadingQuality = this.querySelector('.product-accordion-video__loading-quality');
        this.currentQuality = this.dataset.initialQuality || '';
        this.failedQualities = new Set();
        this.isSwitching = false;
        this.switchContext = null;
        this.restoreTimeout = null;
        this.loadGeneration = 0;

        this.playButton.addEventListener('click', this.handlePlayButtonClick);
        this.video.addEventListener('play', this.handlePlay);
        this.video.addEventListener('pause', this.handlePause);
        this.video.addEventListener('ended', this.handlePause);
        this.video.addEventListener('error', this.handleError);
        this.video.addEventListener('loadedmetadata', this.handleLoadedMetadata);

        if (this.qualityToggle && this.qualityMenu && this.qualityOptions.length) {
          this.qualityToggle.addEventListener('click', this.handleQualityToggleClick);
          this.qualityOptions.forEach((option) => option.addEventListener('click', this.handleQualityOptionClick));
          this.addEventListener('keydown', this.handleKeydown);
          document.addEventListener('click', this.handleDocumentClick);
          this.updateQualitySelection(this.currentQuality);
        }

        if (this.video.readyState >= 1 && this.currentQuality) {
          this.failedQualities.delete(this.currentQuality);
        }
      }

      disconnectedCallback() {
        if (!this.video || !this.playButton) return;

        this.playButton.removeEventListener('click', this.handlePlayButtonClick);
        this.video.removeEventListener('play', this.handlePlay);
        this.video.removeEventListener('pause', this.handlePause);
        this.video.removeEventListener('ended', this.handlePause);
        this.video.removeEventListener('error', this.handleError);
        this.video.removeEventListener('loadedmetadata', this.handleLoadedMetadata);

        if (this.qualityToggle) this.qualityToggle.removeEventListener('click', this.handleQualityToggleClick);
        this.qualityOptions.forEach((option) => option.removeEventListener('click', this.handleQualityOptionClick));
        this.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleDocumentClick);
        window.clearTimeout(this.restoreTimeout);
      }

      handlePlayButtonClick() {
        const playPromise = this.video.play();
        if (playPromise) playPromise.catch(() => this.handlePause());
      }

      handlePlay() {
        this.classList.add('is-playing');
      }

      handlePause() {
        this.classList.remove('is-playing');
      }

      handleError() {
        this.handlePause();
        if (!this.qualityOptions.length) {
          this.playButton.disabled = true;
          return;
        }

        const failedQuality = this.isSwitching ? this.switchContext.pendingQuality : this.currentQuality;
        if (failedQuality) this.failedQualities.add(failedQuality);

        if (!this.switchContext) {
          this.switchContext = {
            state: this.capturePlaybackState(),
            originalQuality: null,
            pendingQuality: failedQuality,
            recovering: false
          };
        }

        const originalQuality = this.switchContext.originalQuality;
        if (!this.switchContext.recovering && originalQuality && !this.failedQualities.has(originalQuality)) {
          this.loadQuality(originalQuality, true);
          return;
        }

        const fallback = this.qualityOptions.find((option) => !this.failedQualities.has(option.dataset.quality));
        if (fallback) {
          this.loadQuality(fallback.dataset.quality, true);
          return;
        }

        this.finishSwitch();
        this.playButton.disabled = true;
      }

      handleLoadedMetadata() {
        if (!this.qualityOptions.length) return;

        if (!this.isSwitching || !this.switchContext) {
          this.failedQualities.delete(this.currentQuality);
          this.updateQualitySelection(this.currentQuality);
          return;
        }

        const state = this.switchContext.state;
        this.video.volume = state.volume;
        this.video.muted = state.muted;
        this.video.playbackRate = state.playbackRate;

        const duration = Number.isFinite(this.video.duration) ? this.video.duration : state.currentTime;
        const targetTime = Math.min(state.currentTime, Math.max(duration - 0.1, 0));
        const generation = this.loadGeneration;
        let restoreCompleted = false;
        const completeRestore = () => {
          if (restoreCompleted || generation !== this.loadGeneration || !this.switchContext) return;
          restoreCompleted = true;
          window.clearTimeout(this.restoreTimeout);
          this.currentQuality = this.switchContext.pendingQuality;
          this.failedQualities.delete(this.currentQuality);
          this.updateQualitySelection(this.currentQuality);
          const shouldResume = state.wasPlaying;
          this.finishSwitch();
          if (shouldResume) {
            const playPromise = this.video.play();
            if (playPromise) playPromise.catch(() => this.handlePause());
          } else {
            this.video.pause();
          }
        };

        if (targetTime > 0.05 && Math.abs(this.video.currentTime - targetTime) > 0.05) {
          this.video.addEventListener('seeked', completeRestore, { once: true });
          this.restoreTimeout = window.setTimeout(completeRestore, 1800);
          try {
            this.video.currentTime = targetTime;
          } catch (error) {
            completeRestore();
          }
        } else {
          completeRestore();
        }
      }

      handleQualityToggleClick() {
        if (this.isSwitching) return;
        this.qualityMenu.hidden ? this.openQualityMenu() : this.closeQualityMenu();
      }

      handleQualityOptionClick(event) {
        if (this.isSwitching) return;
        const quality = event.currentTarget.dataset.quality;
        this.closeQualityMenu();
        if (!quality || quality === this.currentQuality) return;

        this.failedQualities.delete(quality);
        this.switchContext = {
          state: this.capturePlaybackState(),
          originalQuality: this.currentQuality,
          pendingQuality: quality,
          recovering: false
        };
        this.loadQuality(quality, false);
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) this.closeQualityMenu();
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && !this.qualityMenu.hidden) {
          event.preventDefault();
          this.closeQualityMenu();
          this.qualityToggle.focus();
          return;
        }

        if (this.qualityMenu.hidden || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const focusedIndex = this.qualityOptions.indexOf(document.activeElement);
        let nextIndex = focusedIndex;

        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.qualityOptions.length - 1;
        if (event.key === 'ArrowDown') nextIndex = (focusedIndex + 1 + this.qualityOptions.length) % this.qualityOptions.length;
        if (event.key === 'ArrowUp') nextIndex = (focusedIndex - 1 + this.qualityOptions.length) % this.qualityOptions.length;

        this.qualityOptions[nextIndex].focus();
      }

      capturePlaybackState() {
        return {
          currentTime: Number.isFinite(this.video.currentTime) ? this.video.currentTime : 0,
          wasPlaying: !this.video.paused && !this.video.ended,
          volume: this.video.volume,
          muted: this.video.muted,
          playbackRate: this.video.playbackRate
        };
      }

      loadQuality(quality, recovering) {
        const option = this.qualityOptions.find((item) => item.dataset.quality === quality);
        if (!option || !this.switchContext) return;

        this.isSwitching = true;
        this.loadGeneration += 1;
        this.switchContext.pendingQuality = quality;
        this.switchContext.recovering = recovering;
        window.clearTimeout(this.restoreTimeout);
        this.setLoading(true, quality);
        this.closeQualityMenu();
        this.video.src = option.dataset.qualityUrl;
        this.video.load();
      }

      finishSwitch() {
        this.isSwitching = false;
        this.switchContext = null;
        this.setLoading(false);
      }

      setLoading(isLoading, quality) {
        if (!this.loadingIndicator || !this.qualityToggle) return;
        this.loadingIndicator.hidden = !isLoading;
        this.qualityToggle.disabled = isLoading;
        this.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (quality && this.loadingQuality) this.loadingQuality.textContent = quality;
      }

      openQualityMenu() {
        if (!this.qualityMenu || this.isSwitching) return;
        this.qualityMenu.hidden = false;
        this.qualityToggle.setAttribute('aria-expanded', 'true');
        const selectedOption = this.qualityOptions.find((option) => option.getAttribute('aria-checked') === 'true');
        (selectedOption || this.qualityOptions[0]).focus();
      }

      closeQualityMenu() {
        if (!this.qualityMenu || !this.qualityToggle) return;
        this.qualityMenu.hidden = true;
        this.qualityToggle.setAttribute('aria-expanded', 'false');
      }

      updateQualitySelection(quality) {
        if (!quality || !this.qualityToggle || !this.qualityCurrent) return;
        this.qualityCurrent.textContent = quality;
        this.qualityToggle.setAttribute('aria-label', `${this.video.getAttribute('aria-label')}: ${quality}`);
        this.qualityOptions.forEach((option) => {
          option.setAttribute('aria-checked', option.dataset.quality === quality ? 'true' : 'false');
        });
      }
    }

    customElements.define('product-accordion-video', ProductAccordionVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collapsible-text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collapsible-text')) {
    class CollapsibleText extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected || this.controller) return;
        this.viewport = this.querySelector('.collapsible-text__viewport');
        this.body = this.querySelector('.collapsible-text__body');
        this.button = this.querySelector('.collapsible-text__toggle');
        if (!this.viewport || !this.body || !this.button) return;
        this.controller = new AbortController();
        this.savedFocus = new Map();
        this.expanded = false;
        const options = { signal: this.controller.signal };
        this.button.addEventListener('click', () => this.toggle(), options);
        window.addEventListener('resize', () => this.scheduleMeasure(), options);
        this.addEventListener('shopify:block:select', () => {
          this.expanded = true;
          this.measure();
        }, options);
        this.observer = new ResizeObserver(() => this.scheduleMeasure());
        this.observer.observe(this.body);
        document.fonts.ready.then(() => { if (this.isConnected) this.scheduleMeasure(); });
        this.measure();
      }

      scheduleMeasure() {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => this.measure());
      }

      measure() {
        if (!this.isConnected || !this.controller) return;
        const text = this.body.querySelector('p, .content-text') || this.body;
        const style = getComputedStyle(text);
        this.lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
        this.previewHeight = this.lineHeight * (parseInt(getComputedStyle(this).getPropertyValue('--preview-lines'), 10) || 6);
        const fullHeight = this.body.getBoundingClientRect().height;
        this.collapsible = fullHeight > this.previewHeight + 1;
        this.classList.toggle('is-collapsible', this.collapsible);
        this.classList.toggle('is-expanded', this.expanded && this.collapsible);
        this.viewport.style.height = this.collapsible ? `${this.expanded ? fullHeight : this.previewHeight}px` : '';
        this.button.hidden = !this.collapsible;
        this.button.setAttribute('aria-expanded', String(this.expanded || !this.collapsible));
        this.querySelector('.collapsible-text__more').hidden = this.expanded;
        this.querySelector('.collapsible-text__less').hidden = !this.expanded;
        this.updateFocus();
      }

      restoreFocus() {
        if (!this.savedFocus) return;
        this.savedFocus.forEach((saved, element) => {
          if (saved.tabindex === null) element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', saved.tabindex);
          element.inert = saved.inert;
        });
        this.savedFocus.clear();
      }

      updateFocus() {
        this.restoreFocus();
        if (!this.collapsible || this.expanded) return;
        const fadeHeight = parseFloat(getComputedStyle(this.viewport, '::after').height) || 0;
        const visibleBottom = this.viewport.getBoundingClientRect().top + this.previewHeight - fadeHeight;
        this.body.querySelectorAll('a[href], button, input, select, textarea, [tabindex], [contenteditable="true"]').forEach(element => {
          if (element.getBoundingClientRect().bottom > visibleBottom) {
            this.savedFocus.set(element, { tabindex: element.getAttribute('tabindex'), inert: element.inert });
            element.tabIndex = -1;
            element.inert = true;
          }
        });
      }

      toggle() {
        clearTimeout(this.scrollTimer);
        this.expanded = !this.expanded;
        this.measure();
        if (this.expanded) return;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollTimer = setTimeout(() => {
          if (!this.isConnected || this.expanded) return;
          let headerBottom = 0;
          document.querySelectorAll('.shopify-section-header-sticky, .shopify-section-mobile-header-sticky, sticky-header').forEach(header => {
            const rect = header.getBoundingClientRect();
            if (rect.top <= 0 && rect.bottom > 0) headerBottom = Math.max(headerBottom, rect.bottom);
          });
          const buttonRect = this.button.getBoundingClientRect();
          if (buttonRect.top < headerBottom || buttonRect.bottom > window.innerHeight) {
            window.scrollTo({ top: window.scrollY + this.getBoundingClientRect().top - headerBottom - 20, behavior: reduced ? 'instant' : 'smooth' });
          }
        }, reduced ? 0 : 220);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.measureFrame);
        clearTimeout(this.scrollTimer);
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.restoreFocus();
      }
    }
    customElements.define('collapsible-text', CollapsibleText);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mbs26-slide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mbs26-slideshow-gestures')) {
  customElements.define('mbs26-slideshow-gestures', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('slideshow-component').then(() => {
        if (!this.isConnected || this.events) return;
        const host = this.closest('slideshow-component');
        const slider = host?.querySelector('.slideshow__slider');
        if (!slider) return;
        this.events = new AbortController();
        const options = { passive: true, signal: this.events.signal };
        slider.addEventListener('touchstart', event => {
          this.touchActive = event.touches.length === 1 && !event.target.closest('a, button');
          if (this.touchActive) host.touchStart(event);
        }, options);
        slider.addEventListener('touchmove', event => {
          if (event.touches.length !== 1) this.touchActive = false;
          if (this.touchActive) host.touchMove(event);
        }, options);
        slider.addEventListener('touchend', event => {
          if (this.touchActive) host.touchEnd(event);
          this.touchActive = false;
        }, options);
        slider.addEventListener('touchcancel', () => { this.touchActive = false; }, options);
      });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.touchActive = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
